import { useQuery } from '@tanstack/react-query'
import { DONATIONS } from '../constants/endpoints'
import { getDonations } from '../utils/getDonations'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useDonationsQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [DONATIONS, userId],
    queryFn: getDonations,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
